export default __webpack_public_path__ + "static/media/doggy.ff606804.jpg";